import script from "./ConversationActions.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConversationActions.vue?vue&type=script&setup=true&lang=ts"

import "./ConversationActions.vue?vue&type=style&index=0&id=8c0caaee&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8c0caaee"]])

export default __exports__